import React, { useState, useEffect } from 'react';
import Loader from '../../../../components/Loader/Loader';
import axios from 'store/axios/axios-commission-splits';
import { formatUTCtoPST, handleError } from '../../../../shared/utility';
import Notification from '../../../../components/Notification/Notification';
import ReactTable from "react-table";
import { IconButton } from '@material-ui/core';
import { statusDescriptions } from '../../../CommissionSplits/CommissionSplitsLogic';
import Button from '../../../../components/CustomButtons/Button';
import { getUser } from '../../../../shared/authValidation';
import checkPermissionsActions from '../../../../shared/checkPermissionsActions';

const name = 'Commission Splits';

const CommissionSplitsSubTab = (props) => {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState('');
    const { permsAll, perms } = props;

    const load = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entries?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load " + name;
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load '+name+', please try again.');
            setLoading(false);
        }
    }

    const loadEntry = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entry?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load ERTL";
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ERTL, please try again.');
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, []);

    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "date",
                  desc: true,
              },
          ];

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Submitter",
            accessor: "name"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    console.log('CommissionSplitsSubTab', props);

    return (
        <div>
            {permsAll.indexOf('CommissionSplits submit') !== -1 &&
                                <Button color="primary"
                                    onClick={() => {
                                        window.location.href = '/commission_splits?p=new&property_id='+props.property_id;
                                    }}
                                >Create New {name}</Button>}

            {loading && <Loader center={true} /> }

            {entries.length === 0 && <p>No Entry.</p>}

            <div className="react-table-hover-gray">
                <ReactTable
                    defaultSorted={defaultSorted}
                    data={entries.map(entry => {
                        // 1: 'Saved to Draft',
                        // 2: 'Submitted to Final Approver',
                        // 3: 'Submitted to Pending Associates',
                        // 4: 'Approved by Associate',
                        // 5: 'Rejected by Associate',
                        // 6: 'Rejected by Approver Level 1',
                        // 7: 'Rejected by Final Approver',
                        // 8: 'Sent to Pending Approval by Associate',
                        // 9: 'Final Approval',
                        // 10: 'Submitted to Approver Level 1',
                        // 11: 'Approved, Sent for Docusign Signature',
                        // 12: 'Pending Final Signature',
                        // 13: 'Completed Docusign',
                        // 14: 'Rejected Docusign by Associate',
                        // 15: 'Initialed by Associate',
                        // 16: 'Voided'

                        const permissions = checkPermissionsActions('CommissionSplits');
                        const usr = getUser();
                        const obj = {};
                        // Check if Final Approver or Level 1
                        let status = [];
                        if (permissions) {
                            Object.keys(permissions).forEach(p => {
                                if (p === 'approve_level_1') {
                                    status.push(10);
                                }
                                if (p === 'approve_level_2') {
                                    status.push(2);
                                }
                            })
                        }
                        // Check if Agent;
                        console.log('usr', usr);
                        if (usr.type === 'A') {
                            status.push(8);
                        }
                        obj.status = status;
                        let additional = '';
                        let for_review = '';

                        // OWN PROPERTY
                        if (entry.user_id === usr.id) {
                            // My Drafts
                            if (entry.status === 1) {
                                additional = '&tab=my_drafts';
                            }
                            // Pending Associate Review
                            // if (usr.type === 'A' && entry.status === 8) {
                            //     additional = '&tab=pending_approver_review&action_type=view';
                            // }
                            // Pending Further Approval
                            // if (status.indexOf(2) !== -1 && entry.status === 2) {
                            //     additional = '&tab=pending_approver_review&action_type=view';
                            // }
                            // My Completed
                            if (entry.status === 13) {
                                additional = '&tab=my_completed&action_type=view';
                            }
                            // // Voided 
                            // if (entry.status === 16) {
                            //     additional = '&tab=my_voided&action_type=view';
                            // }
                        } else {
                            // SOMEONE ELSE's PROPERTY 
                            if (entry.status === 13) {
                                additional = '&tab=my_completed&action_type=view';
                            }
                            // For Associate Review 
                            // if (usr.type === 'A' && entry.status === 8) {
                            //     for_review = '&tab=pending_approver_review&action_type=edit';
                            // }
                        }

                        if (additional) {
                            additional += '&property_id='+props.property_id;
                        }
                        if (for_review) {
                            for_review += '&property_id='+props.property_id;
                        }

                        
                        return {
                            id: entry.id,
                            created_date: formatUTCtoPST(entry.date_created),
                            modified_date: formatUTCtoPST(entry.date_modified),
                            status: statusDescriptions[entry.status] ? statusDescriptions[entry.status] : '',
                            name: entry.name,
                            actions: <div>
                                {additional && <IconButton
                                    onClick={() => {
                                        window.location.href = '/commission_splits?p=open&cs_id='+entry.id+additional;
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton>}
                                {for_review && <IconButton
                                    onClick={() => {
                                        window.location.href = '/commission_splits?p=open&cs_id='+entry.id+for_review;
                                    }}
                                >
                                    <i className="fa fa-edit"></i>
                                </IconButton>}
                                {<span style={{opacity:0}}>
                                    <IconButton
                                        onClick={() => { }}
                                    >
                                        <i className="fa fa-eye"></i>
                                    </IconButton>
                                </span>}
                            </div>
                        }
                    })}
                    className="-striped"
                    showPaginationTop
                    showPaginationBottom
                    columns={columns}
                    resizable
                    defaultPageSize={10}
                    pageSizeOptions={[10, 20, 30]}
                    minRows={10}
                    filterable
                />
            </div>

            {notification && <Notification 
                open={true}
                close={() => {
                    setNotification('');
                }}
                message={notification}
            />}
        </div>
    );
};

export default CommissionSplitsSubTab;
